<template>
  <div class="search-filters">
    <div
      v-click-outside="clickedOutside"
      :class="['search-filters__item', filterCssConfig]"
    >
      <div
        class="search-filters__toggle caretable caretable--small"
        @click.prevent="openDropDown"
      >
        {{ currentCategory || $t('search.category') }}
        <span class="search-filters__icon arrow_carrot-down"></span>
      </div>
      <div class="search-filters__body">
        <div class="search-filters__title">
          <div class="modal__title">
            {{ $t('search.category') }}
          </div>
          <button class="modal__close search-filters__close">✕</button>
        </div>
        <ul class="search-filters__list">
          <search-filters-option filter="everything" :quantity="0" />
          <search-filters-option
            v-for="(qnt, filter, idx) in filters"
            :key="idx"
            :filter="filter"
            :quantity="qnt"
            :class="{
              'search-filters__option--active':
                translateFilter(filter) === currentCategory,
            }"
            @change="clickedOutside"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchFiltersOption from './search-filters-option/SearchFiltersOption.vue'
import clickOutside from '~/mixins/click-outside'

export default {
  name: 'SearchFilters',
  components: { SearchFiltersOption },
  mixins: [clickOutside],
  props: {
    currentCategory: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    ...mapGetters({ filters: 'searcher/lastCategories' }),
    filterCssConfig() {
      return {
        open: this.open,
        'search-filters__item--set': !!this.currentCategory,
      }
    },
  },
  methods: {
    openDropDown() {
      this.open = true
    },
    translateFilter(filter) {
      return this.$t(`search.product_type_codes.${filter}`)
    },
    clickedOutside() {
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped>
.search-filters {
  margin-bottom: 15px;

  .search-filters__toggle {
    padding: 13px;
    font-size: 13px;
    line-height: 1;
    font-weight: bold;
    border: 1px solid $color_gray;
    border-radius: 3px;
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: $color_gray;
    }
  }

  .search-filters__close {
    display: none;
  }

  .search-filters__icon {
    position: relative;
    top: 1px;
  }

  .search-filters__item {
    margin-right: 5px;
    display: inline-block;

    &:last-child {
      margin-right: 0;
    }

    &.search-filters__item--set .search-filters__toggle {
      border-color: $color_pink;
      background-color: $color_pink;
      color: white;

      &:before,
      &:after {
        background-color: white;
      }
    }
  }

  .search-filters__list {
    padding: 15px;
  }

  .search-filters__body {
    background-color: white;
  }
}

@media (max-width: $screen_larger) {
  .search-filters {
    overflow-x: none;
    margin: 0 -15px 15px;
    padding: 0 15px;
    white-space: nowrap;

    .search-filters__item.open {
      .search-filters__body {
        opacity: 1;
        visibility: visible;
        -webkit-transform: translateY(0);
        transform: translateY(0);
        transition: visibility 0s ease 0s, opacity 0s ease 0s,
          -webkit-transform 0.4s cubic-bezier(0.75, 0, 0.25, 1);
        transition: transform 0.4s cubic-bezier(0.75, 0, 0.25, 1),
          visibility 0s ease 0s, opacity 0s ease 0s;
        transition: transform 0.4s cubic-bezier(0.75, 0, 0.25, 1),
          visibility 0s ease 0s, opacity 0s ease 0s,
          -webkit-transform 0.4s cubic-bezier(0.75, 0, 0.25, 1);
      }
    }

    .search-filters__title {
      padding: 10px 15px;
      position: relative;
      font-size: 20px;
      border-bottom: 1px solid $color_gray;
    }

    .search-filters__close {
      position: absolute;
      color: #666;
      right: 5px;
      top: 0;
      display: block;
      padding: 0 10px;
      line-height: 48px;
      border: 0;
      background: transparent;
    }

    .search-filters__list {
      padding: 10px 0;
    }

    .search-filters__body {
      visibility: hidden;
      opacity: 0;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      outline: 0;
      -webkit-transform: translateY(100%);
      transform: translateY(100%);
      z-index: 10;
      transition: visibility 0s ease 0.2s, opacity 0s ease 0.2s,
        -webkit-transform 0.2s cubic-bezier(0.75, 0, 0.25, 1);
      transition: transform 0.2s cubic-bezier(0.75, 0, 0.25, 1),
        visibility 0s ease 0.2s, opacity 0s ease 0.2s;
      transition: transform 0.2s cubic-bezier(0.75, 0, 0.25, 1),
        visibility 0s ease 0.2s, opacity 0s ease 0.2s,
        -webkit-transform 0.2s cubic-bezier(0.75, 0, 0.25, 1);
    }
  }
}

@media (min-width: $screen_larger) {
  .search-filters {
    margin-bottom: 30px;

    .search-filters__item {
      margin-right: 10px;
      position: relative;

      &.open {
        .search-filters__body {
          opacity: 1;
          visibility: visible;
          z-index: 4;
          top: calc(100% + 10px);
          transition: visibility 0s ease 0s, opacity 0.3s ease 0s,
            top 0.15s ease 0s, -webkit-transform 0s;
          transition: transform 0s, visibility 0s ease 0s, opacity 0.3s ease 0s,
            top 0.15s ease 0s;
          transition: transform 0s, visibility 0s ease 0s, opacity 0.3s ease 0s,
            top 0.15s ease 0s, -webkit-transform 0s;
        }
      }
    }

    .search-filters__title {
      display: none;
    }

    .search-filters__body {
      visibility: hidden;
      opacity: 0;
      left: 0;
      top: 100%;
      width: auto;
      min-width: 256px;
      max-width: 509px;
      border: 1px solid $color_gray;
      border-radius: 3px;
      position: absolute;
      height: fit-content;
      padding: 0 10px;
      -webkit-transform: translateY(0);
      transform: translateY(0);
      z-index: 4;
      transition: visibility 0s ease 0.3s, opacity 0.3s ease 0s,
        top 0.3s ease 0s, -webkit-transform 0s;
      transition: transform 0s, visibility 0s ease 0.3s, opacity 0.3s ease 0s,
        top 0.3s ease 0s;
      transition: transform 0s, visibility 0s ease 0.3s, opacity 0.3s ease 0s,
        top 0.3s ease 0s, -webkit-transform 0s;
    }
  }
}
</style>
